module.exports = __webpack_public_path__ + "static/media/plus-circle-insta.68422569.svg";